import routes from "../../app/routes";

export const getRoutes = (
  mctCurrentPlanYear: string
): { [x: string]: string } => {
  const { questionRouting, beneLanding } = routes;
  const questionsRouteForThisYear = `${questionRouting}?year=${mctCurrentPlanYear}`;
  const questionsRouteForNextYear = `${questionRouting}?year=${mctCurrentPlanYear +
    1}`;
  const beneRouteForThisYear = `${beneLanding}?year=${mctCurrentPlanYear}`;
  const beneRouteForNextYear = `${beneLanding}?year=${mctCurrentPlanYear + 1}`;

  return {
    questionsRouteForThisYear,
    questionsRouteForNextYear,
    beneRouteForNextYear,
    beneRouteForThisYear,
  };
};
